export class TherapistEventDetailsModel {

  public therapistId?: number;
  public eventId?: number;
  public therapistFirstName?: string;
  public therapistLastName?: string;
  public profileLargeURL?: string;
  public profileSmallURL?: string;
  public eventName?: string;
  public venueName?: string;
  public eventAddress?: string;
  public eventCity?: string;
  public eventCountry?: string;
  public eventStartDate?: string;
  public eventEndDate?: string;
  public eventAndTherapistActive?: boolean;
  public therapistEventID?: number;
  public startDate?: string;
  public active?: boolean;
}
